import { Link } from "react-router-dom";

export default function RenderMenuItem(data) {
  return (
    <Link to={data.path}>
      <div
        id={data.name}
        className={`dx-tile-image${data.cardTitle ? " medical-device-card" : ""}`}
      >
        {data.cardTitle && (
          <>
            <div className="medical-device-card__mark">MD</div>
            <div className="medical-device-card__subtitle">
              {data.cardSubtitle}
            </div>
            <div className="medical-device-card__title">
              {data.cardTitle.split("\n").map((line) => (
                <span key={line}>{line}</span>
              ))}
            </div>
          </>
        )}
      </div>
    </Link>
  );
}
